<template>
  <div class="activity-list">
    <Navbar title="活动列表"></Navbar>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="handleList"
    >
      <van-cell
        v-for="item in list"
        :key="item.id"
        :value="item.createAt"
        @click="toDetail(item.id)"
      >
        <template #title>
          <span v-if="item.master" class="activity-icon">主</span>
          <span v-if="!item.master" class="activity-icon copy">副</span>
          <span>{{ item.name }}</span>
        </template>
        <template #label>
          <div
            v-if="item.enableReward"
            class="activity-label activity-label-color"
          >
            用户分销已开启
          </div>
          <div v-if="!item.enableReward" class="activity-label">
            用户分销已关闭
          </div>
        </template>
        <template #default>
          <span>{{ item.createAt }}</span>
          <div class="activity-data" v-if="item.master">
            <div class="join-people">
              <img :src="require('@/assets/join_people.png')" alt="" />
              <span>{{ item.uv }}</span>
            </div>
            <div class="browse-people">
              <img :src="require('@/assets/browse-people.png')" alt="" />
              <span>{{ item.pv }}</span>
            </div>
            <div>
              <img :src="require('@/assets/buy_people.png')" alt="" />
              <span>{{ item.orderPayCount }}</span>
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { activityList } from "@/api/activity";

export default {
  components: {
    Navbar
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },
  methods: {
    // 活动列表
    handleList() {
      activityList().then(res => {
        // console.log("活动列表:", res);
        this.list = res;
        this.finished = true;
      });
    },
    // 跳转详情
    toDetail(id) {
      this.$router.push({ name: "Record", query: { id: id } });
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-list {
  .van-cell {
    align-items: center;

    .activity-icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      margin-right: 5px;
      background-color: #007aff;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      color: #fff;
    }

    .copy {
      background-color: #f08300;
    }

    .activity-label {
      text-indent: 25px;
    }

    .activity-label-color {
      color: #f08300;
    }

    .van-cell__title {
      text-align: left;
    }
    .activity-data {
      display: flex;
      justify-content: flex-end;

      img {
        width: 15px;
        margin-right: 3px;
        vertical-align: text-top;
      }

      .join-people,
      .browse-people {
        margin-right: 15px;
      }
    }
  }
}
</style>
